/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Common_Privacy_PolicyInputs */

const en_auth_common_privacy_policy = /** @type {(inputs: Auth_Common_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const es_auth_common_privacy_policy = /** @type {(inputs: Auth_Common_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica de privacidad`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Auth_Common_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_common_privacy_policy = /** @type {((inputs?: Auth_Common_Privacy_PolicyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Common_Privacy_PolicyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_common_privacy_policy(inputs)
	return es_auth_common_privacy_policy(inputs)
});